import baseApi from '../../base.api'

export const onUpdateUserQueryStarted = async (args, { queryFulfilled, dispatch }) => {
    const filterVariants = [{ organizationOnly: true }, { organizationOnly: false }]

    const updateUserQueryData = filterVariant => {
        dispatch(
            baseApi.util.updateQueryData('fetchUsers', filterVariant, draft => {
                const userIndex = draft?.findIndex(user => user.id === args.id)
                if (userIndex !== -1) draft[userIndex] = { ...draft[userIndex], ...args }
            }),
        )
    }

    try {
        await queryFulfilled
        filterVariants.forEach(filter => updateUserQueryData(filter))
    } catch (error) {
        console.error('Failed to update user query data:', error)
    }
}
